import * as React from 'react'
import styled from 'styled-components'

import { t } from '@owl-nest/localize'
import * as model from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'

import * as projectModel from '../../../../models/project'

type ProjectCancelledPropTypes = {
  project: projectModel.Project
}

export function ProjectCancelled({
  project,
}: ProjectCancelledPropTypes): React.ReactElement<ProjectCancelledPropTypes> {
  return (
    <ProjectCancelledContainer>
      <plume.styles.heading.L>
        {t('Project %(name)s has archived.', { name: model.project.name<projectModel.ExtraFields>(project) })}
      </plume.styles.heading.L>

      <plume.styles.copy.M.light>
        {t('This project has been taken offline at the request of the creator. You can contact him via his profile:')}
      </plume.styles.copy.M.light>

      <Avatar href={project.owner.absolute_url}>
        <plume.styles.image.Avatar src={model.user.avatar(project.owner, '180x180')} />
        <plume.styles.heading.XXXS>{model.user.username(project.owner)}</plume.styles.heading.XXXS>
      </Avatar>
    </ProjectCancelledContainer>
  )
}

const ProjectCancelledContainer = styled.div`
  display: block;
  text-align: center;
  padding: 20px 0;

  ${plume.styles.heading.L} {
    margin-bottom: 20px;
  }

  ${plume.styles.copy.M.light} {
    margin-bottom: 20px;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    width: 100%;
    padding: 0;
  }
`

const Avatar = styled.a`
  ${plume.styles.heading.XXXS},
  ${plume.styles.image.Avatar} {
    display: inline-block;
    vertical-align: middle;
  }
  text-decoration: none;

  ${plume.styles.image.Avatar} {
    margin-right: 8px;
  }
`
